/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import React from 'react';
import { useLanguage } from '@/providers/LanguageProvider';
import Icons from '@/ux-common/src/icons/icons';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Icons as PortalIcons } from '@/components/icons';

interface DropdownMenuProps {
  onEdit: () => void;
  onRemove: () => void;
}

const EllipsesDropdown: React.FC<DropdownMenuProps> = ({
  onEdit,
  onRemove,
}) => {
  const { messages } = useLanguage();
  const compIntl = messages?.ComponentsPage;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <p className="cursor-pointer opacity-0 transition-opacity group-hover:opacity-100">
          {PortalIcons.Ellipses()}
        </p>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="min-w-44 cursor-pointer rounded-none bg-white p-0 text-h5 text-black"
      >
        <DropdownMenuItem
          className="flex cursor-pointer items-center gap-2 p-2 hover:bg-gray-100"
          onClick={onEdit}
        >
          {PortalIcons.Edit('text-fill-button-focus')}
          <span>{compIntl?.switch_or_change}</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className="flex items-center gap-2 p-2 hover:bg-gray-100"
          onClick={onRemove}
        >
          {Icons.Close('text-fill-button-focus size-4')}
          <span>{messages?.General?.remove}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default EllipsesDropdown;
